import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import uuid from "uuid";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";
import ViewPortSize from "../../constants/viewPortSize";
import {
  Container as SideBarItemContainer,
  Item,
  ItemImage,
  ItemText,
  defaultProps,
  propTypes
} from "./SideBarItem";
import { Button as StyledButton } from "../../styled-components";

const Container = styled(SideBarItemContainer)`
  margin-bottom: 0.85rem;
  margin-top: 0.25rem;
  line-height: 0.65rem;
  flex-grow: 0;
`;

const Button = styled(StyledButton)`
  filter: grayscale(${props => (props.disabled ? 1 : 0)});
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  display: flex;
  flex-direction: column;
  min-height: 3.25rem;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0.25rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`;

class SideBarButton extends Component {
  constructor() {
    super();

    this.id = uuid.v4();
  }

  render() {
    const {
      height,
      image,
      text,
      active,
      disabled,
      align,
      viewPortSize
    } = this.props;
    const minimized = viewPortSize < ViewPortSize.LARGE;
    let onClick = this.props.onClick;
    if (disabled) {
      onClick = () => {};
    }
    return (
      <Container height={height} active={active} align={align}>
        <Button
          disabled={disabled}
          onClick={onClick}
          data-tip
          data-for={this.id}
        >
          <FontAwesomeIcon fixedWidth size="2x" icon={image} />
          {!minimized ? <ItemText>{text}</ItemText> : ""}
        </Button>
        {minimized ? (
          <ReactTooltip id={this.id} type="dark" effect="solid">
            <span>{text}</span>
          </ReactTooltip>
        ) : (
          ""
        )}
      </Container>
    );
  }
}

SideBarButton.defaultProps = defaultProps;

SideBarButton.propTypes = {
  ...propTypes,
  viewPortSize: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  viewPortSize: state.app.viewPortSize
});

export default connect(mapStateToProps)(SideBarButton);



// WEBPACK FOOTER //
// ./app/components/SideBar/SideBarButton.js